import React from 'react';
import HowToPlayBlock from './blocks/howToPlayBlock/HowToPlayBlock';
import GamificationMonstersBlock from './blocks/gamificationMonstersBlock/GamificationMonstersBlock';
import StarsChallengeBlock from './blocks/starsChallengeBlock/StarsChallengeBlock';
import FinalHighlightsBlock from './blocks/finalHighlightsBlock/FinalHighlightsBlock';
import TimelineBlock from './blocks/timelineBlock/TimelineBlock';
import PromoBlock from './blocks/promoBlock/PromoBlock';
import VideoGalleryBlock from './blocks/videoGalleryBlock/VideoGalleryBlock'
import ToolboxBlock from './blocks/toolboxBlock/ToolboxBlock';

const registry = {
  howToPlay: HowToPlayBlock,
  timeline: TimelineBlock,
  gamificationMonsters: GamificationMonstersBlock,
  starsChallenge: StarsChallengeBlock,
  promoBlock: PromoBlock,
  finalHighlights: FinalHighlightsBlock,
  toolbox: ToolboxBlock,
  videoGallery: VideoGalleryBlock,
};

const ContestInfoBlockRenderer = ({ block }) => {

  const BlockComponent = registry[block?.type];

  return (
    <>
      {BlockComponent && <BlockComponent {...block.props} />}
    </>
  )
};

export default ContestInfoBlockRenderer;
